import { env } from 'next-runtime-env';

import { isWindowDefined } from '../../Constants/Window';

type Props = {
  data?: any;
  label: string;
  color?: string;
};

export const clientLog = ({ data, color = '#f7f7f7', label }: Props) => {
  if (env('NEXT_PUBLIC_APP_ENV') === 'prod') return;

  const styles = [
    'padding: 5px',
    `background: ${color || 'white'}`,
    'font-weight: 600',
    'color: black',
  ].join(';');

  if (isWindowDefined) console.info(`%c[${label}]`, styles, data);
};
